import React from 'react';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import ThemeSelector from '../../themes/theme-selector';

const PublicHeader = ({
  router,
}) => {
  const theme = ThemeSelector.theme();
  const headerStyle = theme.headerStyle || {};
  const logoStyle = {
    height: theme.headerLogo.size || 40,
    display: 'block',
    margin: '0 auto',
  };
  return (
    <div className="page-navigation-header" style={headerStyle}>
      <img
        onClick={() => router.push('/')}
        className="logo"
        style={logoStyle}
        src={theme.headerLogo.src}
        alt={theme.headerLogo.alt}
      />
    </div>
  );
};

PublicHeader.propTypes = {
  router: PropTypes.object.isRequired,
};

export default withRouter(PublicHeader);



/** WEBPACK FOOTER **
 ** ./src/components/public-header/index.js
 **/